import { Kanban, Handshake, ArrowRight, LogOut } from "lucide-react";

const TILES = [
  { key: "pm", title: "Project Management", desc: "Boards, tasks, chat, timelines & analytics", img: "/hub/pm.png", icon: Kanban, accent: "from-sky-500/30" },
  { key: "crm", title: "CRM", desc: "Contacts, companies & deals pipeline", img: "/hub/crm.png", icon: Handshake, accent: "from-violet-500/30" },
];

export default function HubPage({ user, onChoose, onLogout }) {
  return (
    <div className="min-h-screen bg-[#0b1020] text-white flex flex-col" data-testid="hub-page">
      <header className="flex items-center justify-between px-6 sm:px-10 py-5">
        <div className="flex items-center gap-2">
          <img src="/favicon.png" alt="Opero Smart" className="h-8 w-8 rounded-lg" />
          <span className="font-heading font-bold text-lg">Opero Smart</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-white/60 hidden sm:block">{user?.name || user?.email}</span>
          {onLogout && (
            <button onClick={onLogout} className="p-2 rounded-lg hover:bg-white/10 text-white/60 hover:text-white transition-colors" title="Log out" data-testid="hub-logout-btn"><LogOut className="h-4 w-4" /></button>
          )}
        </div>
      </header>
      <main className="flex-1 flex flex-col items-center justify-center px-4 sm:px-6 pb-16">
        <h1 className="text-2xl sm:text-4xl font-bold mb-2 text-center">Where do you want to work today?</h1>
        <p className="text-white/50 mb-8 sm:mb-12 text-sm sm:text-base text-center">Pick a workspace — you can switch anytime.</p>
        <div className="grid sm:grid-cols-2 gap-5 sm:gap-8 w-full max-w-4xl">
          {TILES.map((t) => (
            <button key={t.key} onClick={() => onChoose(t.key)}
              className="group relative rounded-3xl overflow-hidden border border-white/10 bg-white/5 text-left transition-all duration-300 hover:border-white/30 hover:scale-[1.02] hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-sky-400"
              data-testid={`hub-tile-${t.key}`}>
              <div className="aspect-[16/10] overflow-hidden">
                <img src={t.img} alt={t.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className={`absolute inset-0 bg-gradient-to-t ${t.accent} via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity`} />
              <div className="p-5 sm:p-6 flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <t.icon className="h-5 w-5 text-sky-300" />
                    <h2 className="text-lg sm:text-xl font-bold">{t.title}</h2>
                  </div>
                  <p className="text-xs sm:text-sm text-white/55">{t.desc}</p>
                </div>
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-sky-500 transition-colors shrink-0">
                  <ArrowRight className="h-5 w-5" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
